import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layouts/Layout';

import LoadingScreen from './components/loading/loading';
import 'tippy.js/dist/tippy.css';
import './App.css';
import "./language/i18n";
import { HelmetProvider } from 'react-helmet-async';

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const News = lazy(() => import("./pages/News"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Career = lazy(() => import("./pages/Career"));
const Services = lazy(() => import("./pages/Services"));
const Fleets = lazy(() => import("./pages/Fleets"));
const Fleet1 = lazy(() => import("./pages/fleets/Fleet-1"));
const Fleet2 = lazy(() => import("./pages/fleets/Fleet-2"));
const Fleet3 = lazy(() => import("./pages/fleets/Fleet-3"));
const Fleet4 = lazy(() => import("./pages/fleets/Fleet-4"));
const SVC1 = lazy(() => import("./pages/services/svc-1"));
const SVC2 = lazy(() => import("./pages/services/svc-2"));
const SVC3 = lazy(() => import("./pages/services/svc-3"));
const SVC4 = lazy(() => import("./pages/services/svc-4"));
const News1 = lazy(() => import("./pages/news/news-1"));
const News2 = lazy(() => import("./pages/news/news-2"));
const News3 = lazy(() => import("./pages/news/news-3"));
const News4 = lazy(() => import("./pages/news/news-4"));
const News5 = lazy(() => import("./pages/news/news-5"));
const News6 = lazy(() => import("./pages/news/news-6"));
const News7 = lazy(() => import("./pages/news/news-7"));
const News8 = lazy(() => import("./pages/news/news-8"));
const News9 = lazy(() => import("./pages/news/news-9"));
const News10 = lazy(() => import("./pages/news/news-10"));

function App() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <HelmetProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/news" element={<News />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/fleets" element={<Fleets />} />
              <Route path="/fleets/fleet-1" element={<Fleet1 />} />
              <Route path="/fleets/fleet-2" element={<Fleet2 />} />
              <Route path="/fleets/fleet-3" element={<Fleet3 />} />
              <Route path="/fleets/fleet-4" element={<Fleet4 />} />
              <Route path="/career" element={<Career />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/svc-1" element={<SVC1 />} />
              <Route path="/services/svc-2" element={<SVC2 />} />
              <Route path="/services/svc-3" element={<SVC3 />} />
              <Route path="/services/svc-4" element={<SVC4 />} />
              <Route path="/news/news-5" element={<News5 />} />
              <Route path="/news/news-2" element={<News2 />} />
              <Route path="/news/news-1" element={<News1 />} />
              <Route path="/news/news-3" element={<News3 />} />
              <Route path="/news/news-4" element={<News4 />} />
              <Route path="/news/news-6" element={<News6 />} />
              <Route path="/news/news-7" element={<News7 />} />
              <Route path="/news/news-8" element={<News8 />} />
              <Route path="/news/news-9" element={<News9 />} />
              <Route path="/news/news-10" element={<News10 />} />

              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </Router>
      </HelmetProvider>

    </Suspense>

  );
}

export default App;